module.exports = __webpack_public_path__ + "static/media/arrow-down.7a2df81d.svg";